import { IResponseAllCoordinatorsRowData } from '@interfaces/api/ICoordinator'

const mapCoordinatorTable = (data: IResponseAllCoordinatorsRowData[]) => {
    const mapData = data.map((value) => {
        return {
            ไอดีผู้ประสานงาน: value.coordinator_id,
            ชื่อผู้ประสานงาน: value.coordinator_fullname,
            อีเมล: value.coordinator_email,
            เบอร์โทร: value.coordinator_phone,
            ไอดีสถานะข้อมูล: value.status,
            ชื่อสถานะข้อมูล: value.status_description,
            สร้างเมื่อ: value.created_at,
            สร้างโดยผู้ใช้งานไอดี: value.created_by_user_id,
            สร้างโดยผู้ใช้งานชื่อ: value.created_by_user_fullname,
            แก้ไขเมื่อ: value.updated_at,
            แก้ไขโดยผู้ใช้งานไอดี: value.updated_by_user_id,
            แก้ไขโดยผู้ใช้งานชื่อ: value.updated_by_user_fullname,
        }
    })

    return mapData
}

export default mapCoordinatorTable
